<template>
    <div class="txt-loading">数据加载中…</div>
</template>

<script>
    export default {
        name: 'txt-loading'
    }
</script>
